import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export default styled(NavLink)`
  &.current-link {
    color: #000000;
  }
`;
